import jwt_decode from "jwt-decode"
import { getCookie } from "./cookies"

export const getCookieInfo = () => {
  return !!getCookie() && jwt_decode(getCookie() as string)
}
